//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import UserInfoModule from 'app_components/modules/campus/user/userInfo'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../adminDashboardSidebarModule.scss'

// @ADD Component types
interface IAdminDashboardSidebarModuleLayoutProps {}

const AdminDashboardSidebarModuleLayout: React.FC<IAdminDashboardSidebarModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className='admin_dashboard_sidebar-component'>
      <UserInfoModule showChangePassword />
    </div>
  )
}

export default AdminDashboardSidebarModuleLayout
